module.exports = __webpack_public_path__ + "img/chapter-2-thumb.29ac22fa.jpg";